/* eslint-disable */
import { showPager } from 'src/modern/commonFunctions/commonFuctions';
import Pagination from 'src/modern/pagination/pagination';
import { hideProgress, showProgress } from 'src/modern/progressSpiner/progressSpiner';

$(function () {
    hideProgress();
	initListener()
    loadLandlords();

});

$(document).on('click', '#btn-search-landlords', function (e) {
    loadLandlords();
    $('#landlord-letter-filter li a').removeClass('active');
});

$(document).on('submit', '#landlordSearchForm', function (e) {
    e.preventDefault();

    loadLandlords();
    $('#landlord-letter-filter li a').removeClass('active');
});

$(document).on('click', '#landlord-letter-filter li a', function (e) {
    $('#filterBar .table ul li a').removeClass('active');
    $(this).addClass('active');
});


$(document).on('click', '#city-filter-dropdown li a', function () {
    var selectedCity = $(this).text();
    $('#selected-city-filter').attr('data-selected-city-filter', selectedCity);
    $('#selected-city-filter span').html('City: ' + selectedCity);
    console.log(selectedCity);
    setTimeout(function () {
        loadLandlords();
    }, 100);
});



function initListener() {
    const list = document.querySelectorAll('.js-get-lord');
    if (!list.length) return;
    list.forEach((node) => {
		node.addEventListener('click', (e)=>{
			e.preventDefault()
			const letter = e.currentTarget.innerText
			landlordDirectoryByLetter(letter)
		})
	});
}

function landlordDirectoryByLetter(letter) {
    var selectedCity = $('#selected-city-filter').attr('data-selected-city-filter').toLowerCase();

    if (selectedCity === '' || selectedCity === undefined) {
        selectedCity = 'all';
        //} else {
        //	selectedCity = $('#SelectedCity').val();
    }

    var directoryUrl = '/landlords/directory/starts-with/1/' + selectedCity + '/' + letter;

    showProgress();

    $.get(directoryUrl, function (data) {
        $('#landlordDirectory').hide().html(data).fadeIn('slow');
        hideProgress();
        Pagination()
    });
}

function loadLandlords() {
    var selectedCity = $('#selected-city-filter').attr('data-selected-city-filter').toLowerCase();

    if (selectedCity === '' || selectedCity === undefined) {
        selectedCity = 'all';
    }

    var directoryUrl =
        '/landlords/directory/list/1/' + selectedCity + '/' + $('#appendedInput').val().replaceAll(".","%20");

    showProgress();

    $.get(directoryUrl, function (data) {
        $('#landlordDirectory').html(data)
        hideProgress();
        showPager();
        Pagination()
    }).catch((err)=>{
		hideProgress();
	});
}

